import { useTheme } from '@mui/material';

const useInLightMode = () => {
  const theme = useTheme();
  return theme.palette.mode !== 'dark';
};

export default useInLightMode;
